import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
import colors from '../../theme/colors';
var colorMap = {
    blue: colors.blue[500],
    black: colors.greyscale[100],
    white: colors.white,
    green: colors.green[500],
    purple: colors.purple[500],
    orange: colors.orange[500],
    maroon: colors.maroon[500],
};
var contrastColors = {
    inherit: colors.greyscale[100],
    blue: colors.white,
    black: colors.white,
    white: colors.greyscale[100],
    green: colors.white,
    purple: colors.white,
    orange: colors.white,
    maroon: colors.white,
};
export var styles = function () { return ({
    root: function (_a) {
        var _b = _a.color, color = _b === void 0 ? 'blue' : _b;
        return ({
            color: color === 'inherit' ? color : colorMap[color],
        });
    },
    filled: function (_a) {
        var _b = _a.color, color = _b === void 0 ? 'blue' : _b;
        return ({
            borderRadius: '100%',
            backgroundColor: color === 'inherit' ? color : colorMap[color],
            color: contrastColors[color],
        });
    },
}); };
/**
 * @public
 */
var Logo = forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, _d = _a.classes, classes = _d === void 0 ? { root: null, filled: null } : _d, classNameProp = _a.className, rest = __rest(_a, ["size", "variant", "classes", "className"]);
    var className = clsx(classes.root, variant === 'filled' && classes.filled, classNameProp);
    // Calculate the right size for the filled variant.
    var ratio = 1.35;
    var r2 = (ratio - 1) / 2;
    var svgW = 64.32;
    var svgH = 61.11;
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: variant === 'filled'
            ? -4.755 - r2 * svgW + " " + (-0.046 - r2 * svgH) + " " + ratio *
                svgW + " " + ratio * svgH
            : '0.17 -0.046 54.47 63.92', preserveAspectRatio: "xMidYMin meet", width: convertSize(size), height: convertSize(size), className: className, ref: ref }, rest),
        React.createElement("title", null, "bandwidth-logo"),
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", className: "logo-mark", d: "M43.68,16.18c-2.23-.47-2.5.69-1.54,2.82,5.07,11.18.56,22.1-4.28,24.81a5.93,5.93,0,0,1-.13-1.1c-.57-5.31-2.59-9.92-4-9.92-1.08,0-.4,4.54-.7,8.56-1.79-1.06-2.89-1.8-4.8-1.47-2.75.48-6.38,6.27-6.52,5.44-1.09-6.71,1.52-17,5.14-18.13.56-.22,1.54.63,3.74,1.46,1.72.64,1.5-1.06.71-1.69a8.29,8.29,0,0,0-8.83-.62C17.09,29,14.62,41.05,17.55,46A7.72,7.72,0,0,0,23,49.75c3.65.42,4.76-.34,7.71-3.94a3.42,3.42,0,0,0,1.39.67c-2.4,7.45-11.38,13.73-13.32,12.65C9.38,52.73,12,32.3,18.63,14.33c1.08-2.92,2.86-8.09,3.24-10,1-4.85-5.14-5.78-9.33-2.23-3,2.57-6,8.59-8.35,15.57-7.6,22.18-4.37,40.93,9.24,45,15.66,4.67,23.11-5.07,24.27-14.86a21,21,0,0,0,2.88.15c4.85-.1,11.73-2.6,13.78-13.18C55.92,26.82,50.78,17.53,43.68,16.18Z", fillRule: "evenodd", fill: "currentColor" })));
});
var convertSize = function (size) {
    return ({ small: 8, medium: 24, large: 40 }[size] || size);
};
export default withStyles(styles, { name: 'BwLogo' })(Logo);
/** @private @internal for docs only! */
export var DocsLogo = function (props) { return React.createElement(Logo, __assign({}, props)); };
//# sourceMappingURL=Logo.js.map